import React from "react";
import useIsAr from "../../Hooks/useIsAr";

function TextLayer({ list = [], radius = 0 }) {
  const [isAr] = useIsAr();
  const originX = radius;
  const originY = radius - 20;

  return (
    <svg
      height={radius}
      width={radius * 2 + 30}
      style={{
        position: "absolute",
        bottom: 0,
        zIndex: 3,
        overflow: "visible",
      }}
    >
      {list?.map((item) => {
        const start = -item.min;
        const angle = -90 + (start * 180) / 100;
        const x = radius * Math.sin((angle * Math.PI) / 180);
        const y = radius * Math.cos((angle * Math.PI) / 180);

        return (
          <text
            x={originX}
            y={originY}
            transform={`translate(${x}, ${y})`}
            style={{ fontSize: "13px" }}
          >
            {item.text}%
          </text>
        );
      })}
    </svg>
  );
}

export default TextLayer;
